import * as React from 'react';

import { Provider, inject, observer } from 'mobx-react';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import styles from './styles';

import type ProviderStore from 'connect/web/src/stores/provider-store';
import { computed } from 'mobx';
import PolicyDialog from './controls/policy-dialog';
import PrivacyPolicy from './controls/privacy-policy';
import TermsAndConditions from './controls/terms-and-conditions';
import PolicyDialogStore from './stores/policy-dialog-store';

interface IProps extends WithStyles<typeof styles> {
  providerStore?: ProviderStore;
}

@inject('providerStore')
@observer
class Footer extends React.Component<IProps> {
  private readonly policyDialogStore: PolicyDialogStore = new PolicyDialogStore();

  @computed
  get engineName(): string {
    const { isClick, isEClinic, isGDS, isPPM, isCaseflow } = this.props.providerStore!.license;
    if (isClick) return 'Click';
    if (isEClinic) return 'E-Clinic';
    if (isGDS) return 'GDS';
    if (isCaseflow) return 'Caseflow';
    if (isPPM) return 'PPM';
    return 'TM3';
  }

  @computed
  get engineUrl(): string {
    const { isClick, isEClinic, isGDS, isPPM } = this.props.providerStore!.license;
    if (isClick) return 'https://www.click-hub.com';
    if (isEClinic) return 'https://www.e-clinic.co.uk';
    if (isGDS) return 'https://www.gds.co.uk';
    if (isPPM) return 'https://www.ppmsoftware.com';
    return 'https://www.tm3app.com';
  }

  public render() {
    const { footerContainer, strap, links } = this.props.classes;
    const { embeddedMode } = this.props.providerStore!;

    if (embeddedMode) {
      return null;
    }

    return (
      <Provider policyDialogStore={this.policyDialogStore}>
        <>
          <div className={footerContainer}>
            <div className={links}>
              <PrivacyPolicy />
              <TermsAndConditions />
            </div>
            <div className={strap}>
              <span>
                Connect powered by{' '}
                <a href={this.engineUrl} target="_blank">
                  {this.engineName}
                </a>
              </span>
              <br />© Copyright Blue Zinc IT Ltd 2020
            </div>
          </div>
          <PolicyDialog />
        </>
      </Provider>
    );
  }
}

export default withStyles(styles)(Footer);
